<template>
  <div id="paginaContratti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoContratti -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Contratti</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
                <!-- Timer Alert -->
                <b-col xl="6" md="12">
                  <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                    @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                    <p>Occorre selezionare una riga della tabella</p>
                    <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                  </b-alert>
                </b-col>

                <!-- gridA: gridContratti -->
                <b-col xl="12" md="12" class="pt-1">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="contrattiFullData" :allowSorting="true"
                  :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                  :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                    <e-column field="nomeSoggetto" headerText="Soggetto" width="200"></e-column>
                    <e-column field="titoloSpettacolo" headerText="Spettacolo" width="200"></e-column>
                    <e-column field="tipoContratto" headerText="Tipologia" width="200"></e-column>
                    <!-- <e-column field="statoContratto" headerText="Stato" width="200"></e-column> -->
                    <!-- <e-column field="bozza" headerText="Bozza Contratto" width="150"></e-column> -->
                  </e-columns>
                </ejs-grid>

              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>


    <!-- dialogA: dialogDettaglioContratto ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons"
      :visible="dialogA.visible" :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen"
      :zIndex="dialogA.zIndex" :animationSettings="dialogA.animationSettings">
      <b-row class="match-height">

        <!-- Card con Elementi Input: definizione contratto -->
        <b-col xl="12" md="12">
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Definizione Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>
            </b-card-header>
            <b-card-body class="mb-0">
              <b-row>

                <!-- <b-col xl="12" md="12" class="mb-2">
                  <label for="spettacolo" class="h5">Spettacolo</label>
                  <ejs-dropdownlist id="spettacolo" ref="spettacolo" v-model="contrattiActiveData.spettacolo"
                    :dataSource="spettacoloList" :fields="spettacoloFields"
                    placeholder="Spettacolo" />
                </b-col> -->

                <!-- Input di tipo dropdown senza azioni: contrattiActiveData.spettacolo  -->
                <!-- ESEMPIO ATTUALE AL 30/1/23 di dropdown con ricerca e template, ben funzionante -->
                <!-- da SISTEMARE gestione itemTemplate3 e valueTemplate3 <----------------------------------------------------------  -->
                <b-col xl="12" md="12" class="mb-2">
                  <label for="spettacolo" class="h5">Spettacolo</label>
                  <ejs-dropdownlist id="spettacolo" v-model="contrattiActiveData.spettacolo"
                    :dataSource="spettacoloList" :fields="spettacoloFields"
                    :allowFiltering="true" :itemTemplate='itemTemplate3' :valueTemplate='valueTemplate3'
                    :filtering='spettacoloFiltering' placeholder="spettacolo" />
                </b-col>


                <!-- Input di tipo dropdown senza azioni: contrattiActiveData.soggetto  -->
                <!-- ESEMPIO ATTUALE AL 30/1/23 di dropdown con ricerca e template, ben funzionante -->
                <b-col xl="12" md="12" class="mb-2">
                  <label for="soggetto" class="h5">Soggetto</label>
                  <ejs-dropdownlist id="soggetto" v-model="contrattiActiveData.soggetto"
                    :dataSource="elencoSoggFiltratiList" :fields="elencoSoggFiltratiFields"
                    :allowFiltering="true" :itemTemplate='itemTemplate2' :valueTemplate='valueTemplate2' :change='onSoggettoChange'
                    :filtering='soggettoFiltering' placeholder="soggetto" />
                </b-col>

                <b-col xl="12" md="12" class="mb-2">
                  <label for="scrittura" class="h5">Scrittura Collegata</label>
                  <ejs-dropdownlist id="scrittura" ref="scrittura" v-model="contrattiActiveData.scrittura"
                    :dataSource='scritturaList' :fields='scritturaFields' :itemTemplate='itemTemplate' :change='onScritturaChange'
                    placeholder="Scrittura" />
                </b-col>

                <b-col xl="12" md="12" class="mb-2">
                  <label for="tipocontratto" class="h5">Tipologia Contratto</label>
                  <ejs-dropdownlist id="tipocontratto" ref="tipocontratto" v-model="contrattiActiveData.tipologia"
                    :dataSource="tipoContrattoList" :fields="tipoContrattoFields" placeholder="Tipologia Contratto"
                    :change='onTipologiaContrattoChange' />
                </b-col>


              </b-row>

            </b-card-body>
          </b-card>
        </b-col>

        <!-- Card con Elementi Input: specifiche contratto -->
        <b-col xl="12" md="12" v-show="showContrattoA">
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Specifiche Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>

            </b-card-header>
            <b-card-body class="mb-0">
              <b-row>
                <!-- Input di tipo data: contrattiActiveData.dataContratto -->
                <b-col xl="12" md="12" class="mb-2" >
                  <label for="dataContratto" class="h5"
                    >Data del Contratto</label
                  >
                  <ejs-datepicker
                    id="dataContratto"
                    v-model="contrattiActiveData.dataContratto"
                    :format="settings.formatoData"
                    placeholder="Data Contratto"
                  />
                </b-col>

                <b-col xl="12" md="12" class="text-right mt-1">
                  <ejs-button id="generaContrattoButton" cssClass="e-flat" @click.native="dialogAButtonClick()">Genera Contratto</ejs-button>
                </b-col>
                <!-- da fixare -->
                <b-col xl="12" md="12" class="text-right mt-1"  v-show="showDownloadBozza">
                  <ejs-button id="generaContrattoButton" cssClass="e-flat" @click.native="dialogBDownloadBozza()">Scarica il Contratto</ejs-button>
                </b-col>
              </b-row>

            </b-card-body>
          </b-card>
        </b-col>

        <!-- Card con Elementi Input: Gestione contratto -->
        <b-col xl="12" md="12" v-show="nonMostrare"> <!-- era showGestioneContratto, disabilitato temporaneamente -->
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Gestione Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>
            </b-card-header>
            <b-card-body class="mb-0">
              <b-row>

                <!-- Input di tipo dropdown senza azioni  -->
                <b-col xl="12" md="12" class="mb-2">
                  <label for="stato" class="h5">Stato Contratto</label>
                  <ejs-dropdownlist id="stato" ref="stato" v-model="contrattiActiveData.stato" :dataSource="statoContrattoList"
                    :fields="statoContrattoFields" placeholder="Stato Contratto" />
                </b-col>

                <b-col xl="12" md="12" class="mb-2">
                  <label for="bozzaContratto" class="h5">Bozza Contratto&nbsp;&nbsp;&nbsp;</label>

                  <ejs-button id="bozzaDownload" cssClass="e-flat" @click.native="dialogBDownloadBozza()">
                    Scarica il File
                  </ejs-button>
                </b-col>

                <b-col xl="12" md="12" class="mb-2">
                  <label for="bozzaContratto" class="h5">Gestione Modifiche Contratto&nbsp;&nbsp;&nbsp;</label>

                  <ejs-button id="bozzaDownload" cssClass="e-flat" @click.native="dialogBOpenButtonClick()">
                    Apri
                  </ejs-button>
                </b-col>

                <b-col xl="12" md="12" class="mb-2">
                  <label for="bozzaContratto" class="h5">Gestione Contratto Firmato&nbsp;&nbsp;&nbsp;</label>

                  <ejs-button id="bozzaDownload" cssClass="e-flat" @click.native="dialogCOpenButtonClick()">
                    Apri
                  </ejs-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </ejs-dialog>

    <!-- dialogB: dialogModificaContratto -->
    <ejs-dialog id="dialogB" ref="dialogB" :header="dialogB.header" :buttons="dialogB.buttons"
      :visible="dialogB.visible" :showCloseIcon="dialogB.showCloseIcon" :close="dialogBClose" :open="dialogBOpen"
      :zIndex="dialogB.zIndex" :animationSettings="dialogB.animationSettings">
      <b-row class="match-height">

        <!-- Card con Elementi Input -->
        <b-col xl="12" md="12">
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Modifiche Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>
              <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                </template>
                <b-dropdown-item href="#">
                  ...
                </b-dropdown-item>
              </b-dropdown>
            </b-card-header>
            <b-card-body class="mb-0">
              <!-- card body -->
              <b-row>

                <b-col xl="12" md="12" class="mb-2" v-show="showModificato">
                  <label for="downloadModificato" class="h5">Ultima modifica caricata&nbsp;&nbsp;&nbsp;</label>

                  <ejs-button id="downloadModificato" cssClass="e-flat" @click.native="dialogBDownloadModificato()">
                    Scarica il
                    File
                  </ejs-button>
                </b-col>

                <!-- Input di tipo file upload -->
                <b-col xl="12" md="12" class="mb-2">
                  <label for="contrattoModificato" class="h5">Carica Nuova Modifica</label>
                  <ejs-uploader id="contrattoModificato" ref="uploadObj" name="contrattoModificato"
                    :async-settings="dialogBFileUpload.path" :allowed-extensions="dialogBFileUpload.extensions"
                    :removing="addJWTHeaders" :auto-upload="true" :uploading="dialogBonFileUpload"
                    :success="dialogBafterUpload" :drop-area="dialogBFileUpload.dropElement"
                    :buttons="dialogBFileUpload.buttons" />
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </ejs-dialog>

    <!-- dialogC: dialogFirmaContratto -->
    <ejs-dialog id="dialogC" ref="dialogC" :header="dialogC.header" :buttons="dialogC.buttons"
      :visible="dialogC.visible" :showCloseIcon="dialogC.showCloseIcon" :close="dialogCClose" :open="dialogCOpen"
      :zIndex="dialogC.zIndex" :animationSettings="dialogC.animationSettings">
      <b-row class="match-height">

        <!-- Card con Elementi Input -->
        <b-col xl="12" md="12">
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Firme Contratto</b-card-title>
                <b-card-text class="mb-0" />
              </div>
              <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                </template>
                <b-dropdown-item href="#">
                  ...
                </b-dropdown-item>
              </b-dropdown>
            </b-card-header>
            <b-card-body class="mb-0">
              <!-- card body -->
              <b-row>

                <b-col xl="12" md="12" class="mb-2" v-show="showFirmato">
                  <label for="downloadFirmato" class="h5">Contratto Firmato&nbsp;&nbsp;&nbsp;</label>

                  <ejs-button id="downloadFirmato" cssClass="e-flat" @click.native="dialogCDownloadFirmato()">
                    Scarica il
                    File
                  </ejs-button>
                </b-col>

                <!-- Input di tipo file upload -->
                <b-col xl="12" md="12" class="mb-2">
                  <label for="contrattoFirmato" class="h5">Carica Contratto Firmato</label>
                  <ejs-uploader id="contrattoFirmato" ref="uploadObj" name="contrattoFirmato"
                    :async-settings="dialogCFileUpload.path" :allowed-extensions="dialogCFileUpload.extensions"
                    :removing="addJWTHeaders" :auto-upload="true" :uploading="dialogConFileUpload"
                    :success="dialogCafterUpload" :drop-area="dialogCFileUpload.dropElement"
                    :buttons="dialogCFileUpload.buttons" />
                </b-col>

              </b-row>
            </b-card-body>
          </b-card>
        </b-col>

      </b-row>
    </ejs-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin, FormRatingPlugin,
} from 'bootstrap-vue'
// import Vuexy

// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data'
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin,
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormRatingPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
// api
const contrattiUrl = '/demo/api/contratti'

//const soggettoUrl = '/demo/api/soggetto'
const spettacoloUrl = '/demo/api/spettacolo'
const apiScrittureUrl = '/demo/api/scrittura'
const apiSoggettiUrl = '/demo/api/soggetto'

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='id'>{{data.id}}</span>&nbsp<span class ='personaggio'>{{data.personaggio}}</span><span class ='note'>{{data.note}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

var valueVue = Vue.component("valueTemplate", {
  template: `<span><span class='id'>{{data.id}}</span>&nbsp<span class ='personaggio'>{{data.personaggio}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

var itemVue2 = Vue.component("itemTemplate2", {
  template: `<span><span class='cognome'>{{data.cognome}}</span>&nbsp<span class ='niome'>{{data.nome}}</span><span class ='codFisc'>{{data.codiceFiscale}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

var valueVue2 = Vue.component("valueTemplate2", {
  template: `<span><span class='cognome'>{{data.cognome}}</span>&nbsp<span class ='niome'>{{data.nome}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

var itemVue3 = Vue.component("itemTemplate3", {
  template: `<span><span class='cognome'>{{data.titolo}}</span>&nbsp<span class ='codFisc'>{{data.stagione}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

var valueVue3 = Vue.component("valueTemplate3", {
  template: `<span><span class='cognome'>{{data.titolo}}</span>&nbsp<span class ='niome'>{{data.stagione}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // per dropdownlist con template
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: valueVue };
      },
      itemTemplate2: function () {
        return { template: itemVue2 };
      },
      valueTemplate2: function () {
        return { template: valueVue2 };
      },
      itemTemplate3: function () {
        return { template: itemVue3 };
      },
      valueTemplate3: function () {
        return { template: valueVue3 };
      },
      // scritture
      scrittureFullData:[],
      scritturaActiveData: null,
      // tmp
      showContrattoA: false,
      showContrattoB: false,
      showModificato: false,
      showFirmato: false,
      showGestioneContratto: false,
      showDownloadBozza: false,
      nonMostrare: false,
      settings: {
        // formatoData: { type: 'date', format: 'dd/MM/yyyy' },
        formatoData: 'dd-MM-yyyy',
        formatoOra: { type: 'dateTime', format: 'HH:mm' },
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      contrattiFullData: [],
      contrattiActiveId: 0,
      contrattiActiveData: {},
      contrattiDefaultData: {},
      elencoSoggFiltratiList: [],
      elencoSoggFiltratiFields: { text: 'cognome', value: 'id' },
      spettacoloList: [],
      spettacoloFields: { text: 'titolo', value: 'id' },
      scritturaList: [],
      scritturaFields: { text: 'id', value: 'id' },
      tipoContrattoList: [
        { label: 'Subordinato tecnici a prestazione', id: 1 },
        { label: 'Subordinato tecnici a tempo determinato', id: 2 },
        { label: 'Autonomi tecnici compenso giornaliero', id: 3 },
        { label: 'Autonomi artisti compenso giornaliero', id: 4 },
        { label: 'Autonomi artisti compenso complessivo', id: 5 },
        { label: 'Autonomi artisti compenso recita', id: 6 },
        { label: 'Diritti d\'autore', id: 7 }],
      tipoContrattoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei ruoli
      statoContrattoList: [
        { label: 'Da Generare', val: 'daGenerare' },
        { label: 'Bozza Generata', val: 'bozza' },
        { label: 'Da Inviare', val: 'daInviare' },
        { label: 'Inviato', val: 'inviato' },
        { label: 'Firmato', val: 'firmato' }],
      statoContrattoFields: { text: 'label', value: 'val' }, // specifica i campi da estrarre per popolare la lista dei ruoli
      /* text e' il campo di dataSource visualizzato, value e' il valore inviato */

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogAOk, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogACancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabADialogAIndex: 0,
      },

      // per dialogB
      dialogB: {
        header: 'Gestione Modifiche Contratto',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogBOk, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogBCancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FlipXUp', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogBIndex: 0,
      },

      // per dialogC
      dialogC: {
        header: 'Gestione Contratto Firmato',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogCOk, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogCCancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FlipXUp', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogCIndex: 0,
      },

      // dati per dialogB fileUpload
      dialogBFileUpload: {
        path: {
          saveUrl: `${process.env.VUE_APP_API_ENDPOINT + contrattiUrl}/upload`,
          removeUrl: `${process.env.VUE_APP_API_ENDPOINT + contrattiUrl}/remove`,
        },
        extensions: '.docx, .doc',
        dropElement: '.control-fluid',
        buttons: {
          browse: 'Seleziona un file',
        },
      },

      // dati per dialogC fileUpload
      dialogCFileUpload: {
        path: {
          saveUrl: `${process.env.VUE_APP_API_ENDPOINT + contrattiUrl}/upload`,
          removeUrl: `${process.env.VUE_APP_API_ENDPOINT + contrattiUrl}/remove`,
        },
        extensions: '.pdf',
        dropElement: '.control-fluid',
        buttons: {
          browse: 'Seleziona un file',
        },
      },

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Nuovo',
            tooltipText: 'Inserisci nuovo contratto',
            prefixIcon: 'e-plus',
            id: 'new',
          },
          {
            text: 'Modifica',
            tooltipText: 'Modifica contratto',
            prefixIcon: 'e-expand',
            id: 'edit',
          },
          {
            text: 'Cancella',
            tooltipText: 'Cancella contratto',
            prefixIcon: 'e-cancel',
            id: 'delete',
          },
          // {
          //   text: 'Scarica',
          //   tooltipText: 'Scarica contratto',
          //   prefixIcon: 'e-save',
          //   id: 'download',
          // },
          'Search',
        ],
      },
    }
  },
  created() {

    console.log('Pagina Contratti Creata')
    // inizializzazione elenchi dal backend
    // chiamata API

    // recupero i dati dal backend
    if (localStorage.getItem('userData') !== null) {
      console.log('Recupero elenco contratti, soggetti, spettacoli dal backend per gridA')
      useJwt.get(contrattiUrl).then(d => {
        console.log('Elenco contratti')
        console.log(d.data)
        this.contrattiFullData = d.data
        this.contrattiFullData.forEach(obj => {
          //console.log('OBJ')
          //console.log(obj)
          //obj.nomeSoggetto = `${obj.soggetto.nome} ${obj.soggetto.cognome}`
          obj.nomeSoggetto = this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).nome+' '+this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).cognome
          // trova in tipoContrattoList l'oggetto con id = tipoContratto (stessa cosa per stato)
          obj.statoContratto = this.statoContrattoList.find(x => x.id === obj.val).label
          obj.titoloSpettacolo = this.spettacoloList.find(x => x.id === obj.spettacolo).titolo
          obj.tipoContratto = this.tipoContrattoList.find(x => x.id === obj.tipologia).label
        })
      })

    // soggetti filtrati (artisti e tecnici)
    useJwt.get(apiSoggettiUrl).then(d => {
      console.log('Elenco soggetti anagrafica')
      console.log(d.data)
      this.elencoSoggFiltratiList = d.data
      // filtro in base a isArtista o isTecnico
      const results = this.elencoSoggFiltratiList.filter(obj => {
        return (obj.isArtista === true)||(obj.isTecnico === true);
      });
      console.log('Elenco Soggetti Filtrati')
      console.log(results)
      this.elencoSoggFiltratiList = results
    })


      useJwt.get(spettacoloUrl).then(d => {
        console.log(d.data)
        d.data.forEach(obj => {
          const spettacolo = { id: obj.id, titolo: obj.titolo }
          this.spettacoloList.push(spettacolo)
        })
      })

      // scritture
      useJwt.get(apiScrittureUrl).then(d => {
        console.log('Elenco scritture')
        this.scrittureFullData = d.data
        console.log(this.scrittureFullData)

      })


      console.log('arrivo alla fine di created')
    } else {
      console.log('Non trovo UserData, prova ancora')
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    // per elenco spettacoli: filtra la digitazione per titolo
    spettacoloFiltering: function (e) {
      var searchData = this.spettacoloList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("titolo", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    // per elenco soggetti: filtra la digitazione per cognome
    soggettoFiltering: function (e) {
      var searchData = this.elencoSoggFiltratiList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("cognome", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    // per aggiornamento soggetto
    onSoggettoChange: function (e) {
      console.log("Cambio soggetto")
      console.log(this.contrattiActiveData.soggetto)
      console.log(this.contrattiActiveData.spettacolo)
      // cerco le scritture con lo stesso spettacolo e soggetto
      const results = this.scrittureFullData.filter(obj => {
        return (obj.spettacolo === this.contrattiActiveData.spettacolo)&&(obj.soggetto === this.contrattiActiveData.soggetto);
      });
      console.log('Elenco Scritture con lo stesso spettacolo e soggetto')
      console.log(results)
      this.scritturaList = results
      console.log(this.scritturaList.length)
      // se ne trovo una sola, la assegno direttamente
      if (this.scritturaList.length === 1){
        console.log("UNO")
        console.log("Id unica scrittura corrispondente:")
        console.log(this.scritturaList[0].id)
        this.contrattiActiveData.scrittura = this.scritturaList[0].id
      }
      // reset stato contratto
      this.contrattiActiveData.stato = 'bozza'
      this.$refs.stato.ej2Instances.value = this.contrattiActiveData.stato
      this.$refs.stato.ej2Instances.refresh()

      this.$refs.stato.ej2Instances.value = this.contrattiActiveData.stato
      this.$refs.stato.ej2Instances.refresh()
    },
    // per aggiornamento scrittura
    onScritturaChange: function (e) {
      console.log("Selezionata scrittura")
      // cerco la scrittura selezionata
      console.log('Ricerca Dettagli Scrittura Selezionata')
      const results = this.scrittureFullData.filter(obj => {
        return (obj.id === this.contrattiActiveData.scrittura);
      });
      this.scritturaSel = results
      console.log(this.scritturaSel.length)
      // recupero i dettagli di scrittura
      if (results.length === 1){
        console.log("Dettagli Scrittura Trovati")
        console.log(results[0])
        this.scritturaActiveData=results[0]
        // mappo i dettagli di scrittura nei campi contrattiActiveData corrispondenti
        this.contrattiActiveData.compenso = this.scritturaActiveData.cachetTotale

        this.$refs.tipocontratto.ej2Instances.value = Number(this.scritturaActiveData.tipologia)
        this.$refs.tipocontratto.ej2Instances.refresh()
        this.visualizzaDatiContratto()
      }
    },
    // TODO: capire come avere una sola funzione ma riuscendo ad accedere al contesto (this) anche dentro alla change function
    visualizzaDatiContratto: function () {
      this.showContrattoA = true
      this.showGestioneContratto = true
    },
    // per aggiornamento tipologia contratto
    // capire quali gruppi vanno visualizzati in base a tipo contratto nuovo
    onTipologiaContrattoChange: function (e) {
      console.log('Cambiato')
      this.showContrattoA = true
      this.showGestioneContratto = true
    },
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create()
      uninterceptedAxiosInstance.get(url,
        {
          responseType: 'arraybuffer',
          crossdomain: true,
        }).then(response => {
          this.forceFileDownload(response, title)
        }).catch(() => console.log('error occured'))
    },
    gridAactionBegin(e) {
      console.log('gridAactionBegin')
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      console.log('gridAactionComplete')
    },
    gridAClickHandler(args) {
      console.log('gridAClickHandler()')
      if (args.item.id === 'new') {
        this.dialogA.header = 'Nuovo Contratto'
        console.log('Premuto pulsante creazione nuovo contratto da gridA')
        // contratto corrente da inizializzare con info default
        this.contrattiActiveData.soggetto = null
        this.contrattiActiveData.spettacolo = null
        this.contrattiActiveData.tipologia = null

        this.contrattiActiveId = 0
        this.$refs.dialogA.show(true)
      } else if (args.item.id === 'edit') {
        // TODO: ottimizzare con download la parte di ricerca
        let found = false
        console.log('edit')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.contrattiActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          // console.log(this.contrattiActiveId)

          for (var obj of this.contrattiFullData) {
            if (obj.id === this.contrattiActiveId) {
              console.log('CONTRATTO CORRENTE')
              console.log(obj)
              //obj.datiSoggetto = obj.soggetto // mantengo dati soggetto  <------------- MOD SIMO 23/02
              //obj.soggetto = obj.datiSoggetto.id                         <------------- MOD SIMO 23/02
              this.contrattiActiveData = { ...obj }
              break
            }
          }
          // console.log("CONTRATTI")

          this.$refs.scrittura.ej2Instances.value = this.contrattiActiveData.scrittura
          this.$refs.scrittura.ej2Instances.refresh()

          // console.log(this.contrattiActiveData.contrattoModificato)
          // console.log(this.contrattiActiveData.contrattoFirmato)
          if(this.contrattiActiveData.contrattoModificato)
            this.showModificato = true
          if(this.contrattiActiveData.contrattoFirmato)
            this.showFirmato = true

          this.visualizzaDatiContratto()
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
        this.$refs.dialogA.show(true)

      } else if (args.item.id === 'delete') {

        const removeContrattoUrl = `${contrattiUrl}/remove`
        console.log('delete')
        const selectedRow = this.$refs.gridA.getSelectedRecords()
        console.log(selectedRow[0].id)

        useJwt.post(removeContrattoUrl, { 'contratto_id': selectedRow[0].id }).then(res => {
          console.log(res.data)
          if (res.status === 204) {
            this.makeToast('primary', 'Contratto cancellato correttamente', '')
            this.$refs.gridA.ej2Instances.deleteRecord(); // cancella riga da grid
          } else {
            this.makeToast('primary', 'Attenzione', 'Errore nella cancellazione contratto')
          }
        })
      } else if (args.item.id === 'download') {
        let found = false
        console.log('download elemento')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.contrattiActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.contrattiActiveId)
          // TODO: sistemare iterazione
          for (const i in this.contrattiFullData) {
            if (this.contrattiFullData[i].id === this.contrattiActiveId) {
              console.log("id dell'elenco trovato:")
              console.log('CONTRATTO CORRENTE')
              console.log(this.contrattiFullData[i])
              this.contrattiActiveData = { ...this.contrattiFullData[i] }
              found = true
              break
            }
          }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
        if (found) {
          this.downloadFile(this.contrattiActiveData.urlBozza, this.contrattiActiveData.bozza)
        } else {
          console.log('contratto non trovato')
        }
      }
    },
    dialogAOpen(args) {
      console.log('Apertura dialogA')

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAButtonClick() {
      // bottone "Genera Contratto"
      const self = this
      const generaContrattiUrl = `${contrattiUrl}/genera`
      // distinguere tra creazione ed edit
      if (this.contrattiActiveId === 0) {
        console.log('this.contrattiActiveData');
        console.log(this.contrattiActiveData);
        useJwt.post(generaContrattiUrl, this.contrattiActiveData)
          .then(res => {
            console.log(res.data)
            console.log(res.status)
            let obj = res.data
            //console.log('OBJ')
            //console.log(obj)
            //obj.nomeSoggetto = `${res.data.soggetto.nome} ${res.data.soggetto.cognome}`
            obj.nomeSoggetto = this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).nome+' '+this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).cognome
            obj.statoContratto = this.statoContrattoList.find(x => x.val === obj.stato).label
            obj.titoloSpettacolo = this.spettacoloList.find(x => x.id === obj.spettacolo).titolo
            obj.tipoContratto = this.tipoContrattoList.find(x => x.id === obj.tipologia).label
            this.contrattiFullData.push(obj)
            this.contrattiFullData = [...this.contrattiFullData]

            this.contrattiActiveData = res.data
            console.log(this.contrattiActiveData.stato)
            self.makeToast('primary', 'Successo', 'Contratto generato correttamente')
            this.showDownloadBozza = true

          }).catch(res => {
            console.log(res)
            this.makeToast('primary', 'Attenzione', res.data.errors)
          })
      } else {
        // edit
        const aggiornaContrattiUrl = `${contrattiUrl}/aggiorna`
        useJwt.patch(aggiornaContrattiUrl, this.contrattiActiveData)
          .then(res => {
            console.log(res.data)
            console.log(res.status)
            this.makeToast('primary', 'Contratto modificato correttamente', '')

            let obj = this.contrattiFullData.find(f => f.id === res.data.id)
            if (obj) {
              console.log("OGGETTO TROVATO")
              console.log(obj)
              //obj.nomeSoggetto = `${res.data.soggetto.nome} ${res.data.soggetto.cognome}`
              obj.nomeSoggetto = this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).nome+' '+this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).cognome
              //obj.datiSoggetto = res.data.soggetto   <------------- MOD SIMO 23/02
              //obj.soggetto = res.data.soggetto.id   <------------- MOD SIMO 23/02
              obj.compenso = res.data.compenso
              // spettacolo
              obj.statoContratto = this.statoContrattoList.find(x => x.id === obj.val).label
              obj.titoloSpettacolo = this.spettacoloList.find(x => x.id === obj.spettacolo).titolo
            }

            this.contrattiActiveData = res.data
            // BBB aggiornare correttamente grid, se triggerata qui non funziona
            this.contrattiFullData = [...this.contrattiFullData]
          })
      }
      this.showModificato = false
      this.showFirmato = false
    },

    dialogAClose() {
      console.log('Chiusura dialogA')
    },
    dialogAOk() {
      console.log('Cliccato bottone OK di dialogA')

      useJwt.get(contrattiUrl).then(d => {
        console.log('Elenco contratti')
        console.log(d.data)
        this.contrattiFullData = d.data
        this.contrattiFullData.forEach(obj => {
          //console.log('OBJ')
          //console.log(obj)
          //obj.nomeSoggetto = `${obj.soggetto.nome} ${obj.soggetto.cognome}`
          obj.nomeSoggetto = this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).nome+' '+this.elencoSoggFiltratiList.find(x => x.id === obj.soggetto).cognome
          // trova in tipoContrattoList l'oggetto con id = tipoContratto (stessa cosa per stato)
          obj.statoContratto = this.statoContrattoList.find(x => x.id === obj.val).label
          obj.titoloSpettacolo = this.spettacoloList.find(x => x.id === obj.spettacolo).titolo
          obj.tipoContratto = this.tipoContrattoList.find(x => x.id === obj.tipologia).label
        })
      })

      this.$refs.dialogA.hide()
    },
    dialogACancel() {
      console.log('Cliccato bottone Cancel di dialogA')
      this.contrattiActiveData = {}
      this.$refs.dialogA.hide()
    },

    // per dialogB
    dialogBOpenButtonClick() {
      this.$refs.dialogB.show(true)
    },
    dialogBOpen(args) {
      console.log('Apertura dialogB')
      // assegnare le informazioni da visualizzare nel dialogB

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log('Chiusura dialogB')
    },
    dialogBOk() {
      console.log('Cliccato bottone OK di dialogB')
      this.$refs.dialogB.hide()
    },
    dialogBCancel() {
      console.log('Cliccato bottone Cancel di dialogB')
      this.$refs.dialogB.hide()
    },
    dialogBDownloadBozza() {
      console.log('Cliccato bottone Download Bozza')
      const nomeFile = this.contrattiActiveData.fileDocumento.split('\\').pop().split('/').pop().split('?')[0]
      this.downloadFile(this.contrattiActiveData.fileDocumento, nomeFile)
    },
    dialogBDownloadModificato() {
      console.log('Cliccato bottone Download Modificato')
      const nomeFile = this.contrattiActiveData.contrattoModificato.split('\\').pop().split('/').pop().split('?')[0]
      this.downloadFile(this.contrattiActiveData.contrattoModificato, nomeFile)
    },
    dialogBonFileUpload(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
      // add addition data as key-value pair.
      // eslint-disable-next-line no-param-reassign
      args.customFormData = [{ contratto_id: this.contrattiActiveData.id }]
    },
    dialogBafterUpload(args) {
      console.log(args)
      // Gestire successo upload contratto modificato BBBB
      if (args.name === 'success') {
        console.log('tutto a posto')
        console.log(args.e.target.response)
        const r = JSON.parse(args.e.target.response)
        console.log(r.contrattoModificato)
        this.contrattiActiveData.contrattoModificato = r.contrattoModificato
        this.contrattiActiveData.stato = r.stato
        this.showModificato = true
        this.$refs.stato.ej2Instances.value = this.contrattiActiveData.stato
        this.$refs.stato.ej2Instances.refresh()
      }
    },
    // per dialogC
    dialogCOpenButtonClick() {
      this.$refs.dialogC.show(true)
    },
    dialogCOpen(args) {
      console.log('Apertura dialogC')
      // assegnare le informazioni da visualizzare nel dialogC

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogCClose() {
      console.log('Chiusura dialogC')
    },
    dialogCOk() {
      console.log('Cliccato bottone OK di dialogC')
      this.$refs.dialogC.hide()
    },
    dialogCCancel() {
      console.log('Cliccato bottone Cancel di dialogC')
      this.$refs.dialogC.hide()
    },
    dialogCDownloadFirmato() {
      console.log('Cliccato bottone Download Firmato')
      const nomeFile = this.contrattiActiveData.contrattoFirmato.split('\\').pop().split('/').pop().split('?')[0]
      this.downloadFile(this.contrattiActiveData.contrattoFirmato, nomeFile)
    },
    dialogConFileUpload(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
      // add addition data as key-value pair.
      // eslint-disable-next-line no-param-reassign
      args.customFormData = [{ contratto_id: this.contrattiActiveData.id }]
    },
    dialogCafterUpload(args) {
      console.log(args)
      // Gestire successo upload contratto modificato
      if (args.name === 'success') {
        console.log('tutto a posto')
        console.log(args.e.target.response)
        const r = JSON.parse(args.e.target.response)
        console.log(r.contrattoFirmato)
        this.contrattiActiveData.contrattoFirmato = r.contrattoFirmato
        this.contrattiActiveData.stato = r.stato
        this.$refs.stato.ej2Instances.value = this.contrattiActiveData.stato
        this.$refs.stato.ej2Instances.refresh()
        this.showFirmato = true
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    // per file upload: ?? Serve differenziarli nei vari elementi fileUpload??
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
    },

    noop() {
      console.log("premuto enter")
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}

// per dropdownlist template
.codFisc {
  right: 15px;
  position: absolute;
}

</style>
